/* LAMORE Edit — hero slider + quick add. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSlider(root) {
    if (root.dataset.lrReady) return;
    root.dataset.lrReady = '1';
    var track = root.querySelector('[data-lr-track]');
    var slides = track ? track.children : [];
    var idxEl = root.querySelector('[data-lr-index]');
    if (!track || !slides.length) return;
    var current = 0;
    function mark(i) {
      current = i;
      Array.prototype.forEach.call(slides, function (s, n) { s.classList.toggle('is-current', n === i); });
      if (idxEl) idxEl.textContent = i + 1;
    }
    function go(i) {
      var n = (i + slides.length) % slides.length;
      track.scrollTo({ left: n * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      mark(n);
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 80);
    }, { passive: true });
    var prev = root.querySelector('[data-lr-prev]');
    var next = root.querySelector('[data-lr-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(current - 1);
      if (e.key === 'ArrowRight') go(current + 1);
    });
    mark(0);
  }

  function quickAdd(btn) {
    var id = btn.getAttribute('data-lr-add');
    var label = btn.querySelector('[data-lr-label]');
    var original = label ? label.textContent : '';
    var header = document.getElementById('header-component');
    var headerSection = header && header.closest('.shopify-section');
    var sections = ['cart-drawer-section'];
    if (headerSection) sections.push(headerSection.id.replace('shopify-section-', ''));
    btn.classList.add('is-busy');
    if (label) label.textContent = 'adding…';
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) {
        var s = res.sections || {};
        var target = document.getElementById('shopify-section-cart-drawer-section');
        if (!target || !s['cart-drawer-section']) { window.location.href = '/cart'; return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = s['cart-drawer-section'];
        var fresh = tmp.querySelector('#shopify-section-cart-drawer-section') || tmp;
        target.innerHTML = fresh.innerHTML;
        var hid = sections[1];
        if (hid && s[hid]) {
          var h = document.createElement('div');
          h.innerHTML = s[hid];
          var nb = h.querySelector('[aria-controls="cart-drawer"]');
          var ob = document.querySelector('#header-component [aria-controls="cart-drawer"]');
          if (nb && ob) ob.innerHTML = nb.innerHTML;
        }
        setTimeout(function () {
          var drawer = document.getElementById('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else window.location.href = '/cart';
        }, 120);
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () {
        btn.classList.remove('is-busy');
        if (label) label.textContent = original;
      });
  }

  function init() {
    document.querySelectorAll('[data-lr-slider]').forEach(initSlider);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lr-add]');
    if (b && !b.disabled) { e.preventDefault(); quickAdd(b); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
